import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=7c6aae21&"
import script from "./LabelComponent.vue?vue&type=script&lang=ts&"
export * from "./LabelComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6aae21')) {
      api.createRecord('7c6aae21', component.options)
    } else {
      api.reload('7c6aae21', component.options)
    }
    module.hot.accept("./LabelComponent.vue?vue&type=template&id=7c6aae21&", function () {
      api.rerender('7c6aae21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/LabelComponent.vue"
export default component.exports